import { render } from "./FormCabinas.vue?vue&type=template&id=040e1c84"
import script from "./FormCabinas.vue?vue&type=script&lang=js"
export * from "./FormCabinas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Danben\\Proyectos\\Demos\\duchas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__